exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promoCont {\n  background-color: #99e0e1;\n  color: #fff;\n  text-align: center;\n  padding: 1rem;\n  position: relative;\n  top: -.6em;\n}\n\n.hide {\n  display: none;\n}\n\n.tagLine {\n  font-weight: bold;\n}\n\n.linkText {\n  font-weight: bold;\n  /* text-transform: uppercase; */\n  text-decoration: underline;\n  color: white;\n  cursor: pointer;\n  padding: 0;\n}\n", ""]);

// exports
